import * as React from "react"
import { useLocation } from "@gatsbyjs/reach-router"

import "../styles/layout.css"
import Navigation from "./navigation"
import PageTransition from "./page-transition"
import CVRequestModal from "./CVRequestModal"
import InteractiveDotBackground from "./InteractiveDotBackground"
import NowPlaying from "./now-playing"

const Layout = ({ children }) => {
  const location = useLocation()

  const pathname = location?.pathname || ""
  const isColdTakeRoute =
    pathname === "/cold-take" || pathname.startsWith("/cold-take/")
  const isPixelRoute = pathname === "/pixel" || pathname.startsWith("/pixel/")
  const isReplRoute = pathname === "/repl" || pathname.startsWith("/repl/")
  const isTeletextRoute = pathname === "/teletext" || pathname.startsWith("/teletext/")
  const isReplEmbedRoute =
    isReplRoute &&
    (/^\/repl\/[^/?#]+\/embed\/?$/.test(pathname) ||
      new URLSearchParams(location?.search || "").has("embed"))
  const isImmersiveRoute =
    isColdTakeRoute || isPixelRoute || isReplEmbedRoute || isTeletextRoute

  React.useEffect(() => {
    if (typeof document === "undefined") return undefined

    if (!isTeletextRoute) {
      document.documentElement.classList.remove("is-teletext-handoff")
    }

    return undefined
  }, [isTeletextRoute])

  return (
    <div className="page-shell flex flex-col min-h-screen" data-glass-root>
      <InteractiveDotBackground />
      <main
        className="z-1 flex flex-1 font-display overflow-hidden"
        data-nav-glass-surface
      >
        <PageTransition>{children}</PageTransition>
      </main>
      {!isImmersiveRoute ? (
        <>
          <CVRequestModal />
          <Navigation />
          <NowPlaying />
        </>
      ) : null}
    </div>
  )
}

export default Layout
